import React from 'react';
import { styled } from '@mui/material/styles';
import { Alert } from '@mui/material';
import Box from '@mui/material/Box';

export enum AlertType {
    success = 'success',
    info = 'info',
    warning = 'warning',
    error = 'error',
}

export type TowerAlert = {
    type: AlertType;
    message: string;
};

const StyledAlert = styled(Alert)`
    height: 23px;
    border-radius: 2px;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

interface Props {
    alerts: TowerAlert[];
}
const Alerts = ({ alerts }: Props) => {
    if (alerts == null || alerts.length === 0) {
        return null;
    }
    return (
        <Box mb="30px">
            {alerts.map(({ type, message }: TowerAlert, index: number) => (
                <StyledAlert
                    key={`alert-${type}-${index}`}
                    variant="filled"
                    severity={type}
                    icon={false}
                >
                    {message}
                </StyledAlert>
            ))}
        </Box>
    );
};
export default Alerts;
